var render, staticRenderFns
import script from "./ErrorPageWrapper.vue?vue&type=script&lang=js"
export * from "./ErrorPageWrapper.vue?vue&type=script&lang=js"
import style0 from "./ErrorPageWrapper.vue?vue&type=style&index=0&id=6306ce16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6306ce16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/_work/studio-admin/studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6306ce16')) {
      api.createRecord('6306ce16', component.options)
    } else {
      api.reload('6306ce16', component.options)
    }
    
  }
}
component.options.__file = "src/views/ErrorPageWrapper.vue"
export default component.exports